/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { StoreActions } from '../../../core/context/store';

import { ApiService } from '../../../core/services';
// eslint-disable-next-line import/no-cycle

export const getCollections =
  (sessionId: number, callbackSuccess: () => void = () => null) =>
  async (actions: StoreActions<any>): Promise<void> => {
    try {
      const response = await ApiService.get<any, any>(`v2/sessions/${sessionId}/pulse-sequences/collections`);
      callbackSuccess();
      actions.setValue(response.data);
    } catch (err: any) {
      actions.setError(err.message);
    }
  };

export const createNewCollection =
  (sessionId: number, collectionName: string, callbackSuccess: () => void = () => null) =>
  async (actions: StoreActions<any>): Promise<void> => {
    try {
      const response = await ApiService.post<any, any>(`v2/sessions/${sessionId}/pulse-sequences/collections`, {
        name: collectionName,
      });
      callbackSuccess();
      actions.setValue(response.data);
    } catch (err: any) {
      actions.setError(err.message);
    }
  };

export const getPulseSequencesInCollection =
  (sessionId: number, collectionId: string, callbackSuccess: () => void = () => null) =>
  async (actions: StoreActions<any>): Promise<void> => {
    try {
      const response = await ApiService.get<any, any>(
        `v1/sessions/${sessionId}?pulseSequenceCollectionId=${collectionId}`
      );
      callbackSuccess();
      actions.setValue(response.data);
    } catch (err: any) {
      actions.setError(err.message);
    }
  };
